import { render, staticRenderFns } from "./QuirofanoListaCirugias.vue?vue&type=template&id=91320810&"
import script from "./QuirofanoListaCirugias.vue?vue&type=script&lang=js&"
export * from "./QuirofanoListaCirugias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports